module.exports = __webpack_public_path__ + "img/restart.d018cb99.png";